import { Star } from '@phosphor-icons/react'

interface RatingStarsProps {
  value: number // 0-5, accepts decimals
  size?: number
  showValue?: boolean
  count?: number
  className?: string
}

export function RatingStars({ value, size = 16, showValue = false, count, className = '' }: RatingStarsProps) {
  const rounded = Math.round(value * 2) / 2 // half-step
  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      <span className="inline-flex items-center" aria-label={`${value} de 5`}>
        {[1, 2, 3, 4, 5].map((i) => {
          if (rounded >= i) {
            return <Star key={i} size={size} weight="fill" className="text-amber-400" />
          } else if (rounded >= i - 0.5) {
            return (
              <span key={i} className="relative inline-block" style={{ width: size, height: size }}>
                <Star size={size} className="text-amber-400 absolute inset-0" />
                <span className="absolute inset-0 overflow-hidden" style={{ width: size / 2 }}>
                  <Star size={size} weight="fill" className="text-amber-400" />
                </span>
              </span>
            )
          }
          return <Star key={i} size={size} className="text-gray-300" />
        })}
      </span>
      {showValue && (
        <span className="text-sm font-medium text-gray-700">
          {value > 0 ? value.toFixed(1) : '-'}
          {count !== undefined && (
            <span className="text-gray-400 font-normal ml-1">({count})</span>
          )}
        </span>
      )}
    </span>
  )
}

interface RatingInputProps {
  value: number
  onChange: (n: number) => void
  size?: number
}

export function RatingInput({ value, onChange, size = 28 }: RatingInputProps) {
  return (
    <div className="inline-flex items-center gap-1">
      {[1, 2, 3, 4, 5].map((i) => (
        <button
          key={i}
          type="button"
          onClick={() => onChange(i)}
          className="transition-transform hover:scale-110"
          aria-label={`${i} estrelas`}
        >
          <Star
            size={size}
            weight={i <= value ? 'fill' : 'regular'}
            className={i <= value ? 'text-amber-400' : 'text-gray-300 hover:text-amber-300'}
          />
        </button>
      ))}
    </div>
  )
}
